<template>
  <!-- Tablero de control -->
  <v-data-table
    v-model="selected"
    v-model:page="itemsPerPage"
    :headers="headers"
    :items="desserts"
    :search="search"
    item-value="IdentificadorUnico"
    show-select
    return-object
  >
    <template v-slot:top>
      <v-toolbar flat>
        <!-- Campos -->
        <v-dialog v-model="dialogframecreate" persistent max-width="900px">
          <template v-if="param1[1] == '1'" v-slot:activator="{ props }">
            <v-btn
              color="green"
              icon="mdi-plus"
              size="x-large"
              dark
              class="mb-2"
              v-bind="props"
            >
            </v-btn>
          </template>
          <v-card>
            <v-toolbar dark color="red-darken-4">
              <v-toolbar-title
                ><v-icon left>{{ iconTitle }}</v-icon> {{ formTitle }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  class="d-none d-md-block"
                  dark
                  text
                  @click="
                    dialogframecreate = false;
                    editedItem = null;
                    editedIndex = -1;
                  "
                  >Cerrar</v-btn
                >
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <proceso-registro
                v-if="dialogframecreate"
                :infoedit="editedItem"
                v-bind:page="dialogframecreate"
                v-on:update:page="dialogframecreate = $event"
                v-bind:Exito="respuestapostput"
                v-on:update:Exito="respuestapostput = $event"
                :infopermisos="param1"
                :tipodocumento="typedocument"
                :documento="document"
                :editedIndex="editedIndex"
                :infollaves="infollaves"
              ></proceso-registro>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-divider
          v-if="param1[1] == '1'"
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <!-- Eliminación -->
        <v-btn
          v-if="param1[3] == '1'"
          color="red"
          icon="mdi-delete"
          dark
          class="mb-2"
          @click="Eliminar"
        >
        </v-btn>
        <v-divider
          v-if="param1[3] == '1'"
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <!-- Filtros -->
        <v-dialog v-model="dialogframe" persistent max-width="1000px">
          <template v-slot:activator="{ props }">
            <v-btn
              color="cyan"
              icon="mdi-filter-menu"
              dark
              class="mb-2"
              v-bind="props"
            >
            </v-btn>
          </template>
          <v-card>
            <v-toolbar dark color="red-darken-4">
              <v-toolbar-title
                ><v-icon left>mdi-filter-menu</v-icon> Filtros
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn class="d-none d-md-block" dark text @click="reset"
                  >Limpiar</v-btn
                >
                <v-btn
                  class="d-none d-md-block"
                  dark
                  text
                  @click="ValidateCampos"
                  >Consultar</v-btn
                >
                <v-btn
                  class="d-none d-md-block"
                  dark
                  text
                  @click="dialogframe = false"
                  >Cerrar</v-btn
                >
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-form ref="form" autocomplete="off">
                <v-row v-for="(datos, i) in modelfiltro" :key="i">
                  <!-- Filtro -->
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="datos.filtro"
                      :items="items"
                      item-title="descripcion"
                      item-value="filtro"
                      label="Tipo de filtro:"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    ></v-autocomplete>
                  </v-col>
                  <!-- Contenido -->
                  <!-- Clase de comunicación  -->
                  <v-col v-if="i == 2" cols="12" sm="6" md="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayTipoNewContact"
                      :item-title="
                        (ArrayTipoNewContact) =>
                          ArrayTipoNewContact.Valor +
                          '-' +
                          ArrayTipoNewContact.Descripcion
                      "
                      item-value="Valor"
                      color="primary"
                      label="Clase:"
                      dense
                      clearable
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                    >
                    </v-autocomplete>
                  </v-col>
                  <!-- Tipo de persona -->
                  <v-col v-else-if="i == 3" cols="12" sm="6" md="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayClaseNewContact"
                      :item-title="
                        (ArrayClaseNewContact) =>
                          ArrayClaseNewContact.Valor +
                          '-' +
                          ArrayClaseNewContact.Descripcion
                      "
                      item-value="Valor"
                      color="primary"
                      label="Tipo de persona:"
                      dense
                      clearable
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col v-else cols="6">
                    <v-text-field
                      v-model="datos.contenido"
                      :label="datos.label"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <!-- Buscador -->
        <v-text-field
          v-model="search"
          append-inner-icon="mdi-magnify"
          label="Buscar..."
          single-line
          variant="underlined"
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <!-- Acciones  -->
    <template v-slot:item.actions="{ item }">
      <div class="text-left">
        <!-- Modificación  -->
        <v-tooltip
          v-if="param1[2] == '1' || param1[0] == '1'"
          location="bottom"
          color="white"
        >
          <template v-slot:activator="{ props }">
            <v-icon
              color="#05AD58"
              @click="editItem(item.raw, 0)"
              v-bind="props"
              >{{
                param1[2] == "1" && param1[0] == "0" && item.raw.IndModficable != "S" ? "mdi-pencil" : "mdi-eye"
              }}</v-icon
            >
          </template>
          <span>{{
            param1[2] == "1" && param1[0] == "0" && item.raw.IndModficable != "S" ? "Modificar" : "Consultar"
          }}</span>
        </v-tooltip>
        <!-- LLamada  -->
        <v-tooltip
          v-if="item.raw.Clase == '2' || item.raw.Clase == '3'"
          location="bottom"
          color="white"
        >
          <template v-slot:activator="{ props }">
            <v-icon color="light-blue-darken-4" v-bind="props">
              mdi-phone-in-talk
            </v-icon>
          </template>
          <span> LLamar cliente </span>
        </v-tooltip>
        <!-- Parentesco  -->
        <v-tooltip v-if="item.raw.Tipo == '1'" location="bottom" color="white">
          <template v-slot:activator="{ props }">
            <v-icon color="green-accent-2" v-bind="props">
              mdi-human-male-female-child
            </v-icon>
          </template>
          <span> {{ item.raw.Nombre }} - {{ item.raw.DescParenteso }} </span>
        </v-tooltip>
      </div>
    </template>
    <!-- Comuncación  -->
    <template v-slot:item.Contenido="{ item }">
      <div>
        <span v-if="item.raw.Clase == '2' || item.raw.Clase == '3'">
          {{ item.raw.Phone }}
          {{
            item.raw.Ext != "" && item.raw.Ext != null
              ? "- ext: " + item.raw.Ext
              : ""
          }}
        </span>
        <span v-else>
          {{ item.raw.EmailPageWeb }}
        </span>
      </div>
    </template>
    <!-- Acciones  -->
    <template v-slot:item.Observaciones="{ item }">
      <div class="text-center">
        <!-- Parentesco  -->
        <v-tooltip
          v-if="item.raw.Observaciones != '' && item.raw.Observaciones != null"
          location="bottom"
          color="white"
        >
          <template v-slot:activator="{ props }">
            <v-icon color="blue" v-bind="props"> mdi-information </v-icon>
          </template>
          <span> {{ item.raw.Observaciones }} </span>
        </v-tooltip>
      </div>
    </template>
  </v-data-table>
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Registro from "@/views/TCI/Personas/NuevoContacto/NuevoContactoRegistro.vue";
export default {
  name: "NuevoContacto",
  props: {
    typedocument: {
      type: Number,
      default: 0,
      Description: "Información de llaves",
    },
    document: {
      type: String,
      default: null,
      Description: "Información de llaves",
    },
    infopermisos: {
      type: String,
      default: "0111",
      Description: "Información de permisos",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
  },
  components: {
    "proceso-registro": Registro,
  },
  data() {
    return {
      itemsPerPage: 1,
      selected: [],
      search: "",
      consult: false,
      respuestapostput: null,
      editedItem: null,
      editedIndex: -1,
      progreso: false,
      dialogframe: false,
      dialogframecreate: false,
      dialogframeboton: false,
      iconodialogbtn: "",
      titledialogbtn: "",
      componenteview: 0,
      menubuttoms: [],
      items: [
        {
          filtro: "=",
          descripcion: "Igual a",
        },
        {
          filtro: "LIKE",
          descripcion: "Similar a",
        },
        {
          filtro: ">=",
          descripcion: "Mayor igual a",
        },
        {
          filtro: "<=",
          descripcion: "Menor igual a",
        },
      ],
      modelfiltro: [
        {
          campo: "TypeDocument",
          filtro: null,
          contenido: null,
          lectura: true,
          clear: false,
          label: "Tipo de documento:",
        },
        {
          campo: "DocumentID",
          filtro: null,
          contenido: null,
          lectura: true,
          clear: false,
          label: "Documento:",
        },
        {
          campo: "Clase",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Clase de persona:",
        },
        {
          campo: "Tipo",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: false,
          label: "Tipo de comunicación:",
        },
        {
          campo: "Phone",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Teléfono fijo/Celular:",
        },
        {
          campo: "EmailPageWeb",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Correo electrónico/Página web:",
        },
      ],
      headers: [
        {
          title: "Acciones",
          key: "actions",
          align: "left",
          sortable: false,
        },
        {
          title: "Contenido",
          key: "Contenido",
        },
        {
          title: "Observaciones",
          key: "Observaciones",
          align: "center",
          sortable: false,
        },
      ],
      desserts: [],
      param1: [],
      busquedacompleta: false,
      ArrayTipoNewContact: [],
      ArrayClaseNewContact: [],
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Crear Registro"
        : this.param1[2] == "1" && this.param1[0] == "0"
        ? "Actualizar registro"
        : "Consultar registro";
    },
    iconTitle() {
      return this.editedIndex === -1
        ? "mdi-plus"
        : this.param1[2] == "1" && this.param1[0] == "0"
        ? "mdi-pencil"
        : "mdi-eye";
    },
  },
  watch: {
    dialogframecreate(val) {
      if (!val && this.respuestapostput == "Exito" && this.consult) {
        this.respuestapostput = null;
        this.ValidateCampos();
        this.itemsPerPage = 1;
      }
    },
  },
  methods: {
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      this.consult = validate;
      this.busquedacompleta = false;
      for (var i = 0; i < this.modelfiltro.length; i++) {
        if (
          (this.modelfiltro[i].filtro == "" ||
            this.modelfiltro[i].filtro == null) &&
          this.modelfiltro[i].contenido != "" &&
          this.modelfiltro[i].contenido != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido == "" ||
            this.modelfiltro[i].contenido == null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido != "" ||
            this.modelfiltro[i].contenido != null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          this.busquedacompleta = true;
        }
      }
      // Consultas a Ejecutar
      if (!validate) {
        this.consult = true;
        this.getConsultData();
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos o no contiene el respecitivo filtro.",
        });
      }
    },
    // Consulta Tablero
    async getConsultData() {
      this.desserts = [];
      this.selected = [];
      this.progreso = true;
      var data = {
        filtrado: this.modelfiltro,
        busquedacompleta: this.busquedacompleta,
        parametro1: this.param1,
      };
      this.axios
        .post("/Personas/NuevoContacto/CT0/", data)
        .then((result) => {
          this.desserts = result.data;
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
          this.dialogframe = false;
        });
    },
    // Item editar
    editItem(item, iconoelegido) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogframecreate = true;
      switch (iconoelegido) {
        case 1: // Direcciones
          this.iconodialogbtn = "mdi-map-marker-plus";
          this.titledialogbtn = "Direcciones";
          break;
        case 2: //Histórico de datos
          this.iconodialogbtn = "mdi-file-multiple-outline";
          this.titledialogbtn = "Histórico de datos";
          break;
        case 3: //Histórico de procesos
          this.iconodialogbtn = "mdi-folder-search-outline";
          this.titledialogbtn = "Histórico de procesos";
          break;
        case 4: //Trazabilidad
          this.iconodialogbtn = "mdi-chat-processing";
          this.titledialogbtn = "Trazabilidad";
          break;
      }
    },
    // Confirmación de eliminación
    Eliminar() {
      if (this.selected.length != 0 && this.selected != null) {
        this.$swal({
          icon: "question",
          title: "Eliminar Información",
          html: "¿Está seguro que desea eliminar la información seleccionada?<br>Esta acción no se puede deshacer luego de confirmarla.",
          confirmButtonText: "Sí",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.isConfirmed) {
            this.getDelete();
          }
        });
      } else {
        this.$swal({
          icon: "info",
          title: "Seleccione la fila a eliminar",
          html: "Lo sentimos, debe seleccionar la celda o celdas para eliminar el registro.",
        });
      }
    },
    // Consulta las eliminaciones
    async getDelete() {
      this.axios
        .delete("/Personas/NuevoContacto/", { data: this.selected })
        .then((response) => {
          if (response.data === "Exito") {
            this.$swal({
              icon: "success",
              title: "Información Eliminada",
              html: "La información se ha eliminado correctamente.",
            });
            this.getConsultData();
            this.selected = [];
          } else {
            this.$swal({
              icon: "error",
              title: "Error al guardar los datos",
              html: response.data.toString(),
            });
          }
        })
        .catch((e) =>
          this.$swal({
            icon: "error",
            title:
              "No se logro la eliminación debido a que tiene datos relacionados",
            html:
              "Lo sentimos, ocurrió un error al intentar consultar los datos del proceso:<br><small><code>" +
              e.toString() +
              "</code></small>",
          })
        );
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    // Limpiar campos
    reset() {
      this.busquedacompleta = false;
      this.$refs.form.reset();
      if (this.pageiframe) {
        for (var i = 0; i < 2; i++) {
          this.modelfiltro[i].filtro = "=";
          if (i == 0) {
            this.modelfiltro[i].contenido = this.typedocument;
          } else if (i == 1) {
            this.modelfiltro[i].contenido = this.document;
          }
          this.modelfiltro[i].lectura = true;
          this.modelfiltro[i].clear = false;
        }
      }
    },
    // Busca los parametros de la pagina
    parametrospaginas() {
      var page = this.$store.getters.userperfil.paginainfo;
      if (page.param1) {
        var splitparam1 = page.param1.split("");
        this.param1 = splitparam1;
      }
    },
    // Parametros Iframe
    parametrosiframe() {
      for (var i = 0; i < 2; i++) {
        this.modelfiltro[i].filtro = "=";
        if (i == 0) {
          this.modelfiltro[i].contenido = this.typedocument;
        } else if (i == 1) {
          this.modelfiltro[i].contenido = this.document;
        }
        this.modelfiltro[i].lectura = true;
        this.modelfiltro[i].clear = false;
      }
      var splitparam1 = this.infopermisos.split("");
      this.param1 = splitparam1;
      this.ValidateCampos();
    },
  },
  mounted() {
    this.ArrayTipoNewContact = this.$store.getters.MTablaSeleccion.filter(
      (item) => item.Valor != null && item.TablaId == 37
    );
    this.ArrayClaseNewContact = this.$store.getters.MTablaSeleccion.filter(
      (item) => item.Valor != null && item.TablaId == 35
    );
    if (!this.pageiframe) {
      this.parametrospaginas();
    } else {
      this.parametrosiframe();
    }
  },
};
</script>
